import { createSlice } from '@reduxjs/toolkit';

export type AemContentState = {
  data: {
    isLoading: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
  };
};
export const initialState: AemContentState = {
  data: {
    isLoading: false
  }
};

export const slice = createSlice({
  name: 'aemContent',
  initialState,
  reducers: {
    setInitialState: (state, { payload }) => {
      state.data[payload] = initialState.data;
    },
    setIsLoading: (state, { payload }) => {
      state.data[payload].isLoading = true;
    },
    setSuccess: (state, { payload }) => {
      state.data[payload.id] = payload;
      state.data[payload.id].isLoading = false;
    }
  }
});

export const { setInitialState, setIsLoading, setSuccess } = slice.actions;

export const selectSlice = (state) => state[slice.name];
export const selectData = (state) => selectSlice(state).data;

export const selectDataByJourney = (pageId) => (state) =>
  selectData(state)[pageId];

export default slice.reducer;
